import React from 'react'
import './Courses-main.css';
import coursesBanner from './img/courses-bannner.png';
import linux from './img/linus.png';
import img3 from './img/Course-img3.jpg';
import img4 from './img/course-img4.jpg';
import img5 from './img/course-img5.jpg';
// import ccna from './img/ccna.png';
import ccna from './img/ccna1.png';
import img8 from './img/course-img8.jpg';
import img9 from './img/course-img9.jpg';
import cisco from './img/cisco-img.jpg';
import FAQ from './FAQ';
import Footer from '../Components/footer';
import { Link } from 'react-router-dom';


const CoursesMain = () => {
  return (
    <div className='courses-main'>
      <div className='courses-container'>
        <div className='courses-top-box'>
        <div className='courses-banner'>
          <div className='courses-banner'>
<img src={coursesBanner} alt=''/>
          </div>
        </div>
       <div className='courses-top-heading'>
<h1>Popular Cybersecurity Courses</h1>
<p>Want to learn cybersecurity? Master network security, encryption, cryptography, and cloud security with hands-on training and real-world projects.Gain hands-on skills to protect data and secure modern systems.</p>
       </div>
       </div>
       <div className='courses-bottom-box'>
<div className='courses-item'>
<div className='courses-img'>
<img src={cisco} alt=''/>
</div>
<div className='course-content'>
  <h2>Cisco Certificate</h2>
<div className='course-btn'>
    <Link to="/CiscoPage">
  <button>View Course</button>
</Link>
</div>
</div>
</div>
<div className='courses-item'>
<div className='courses-img'>
<img src={linux} alt=''/>
</div>
<div className='course-content'>
  <h2>Linux</h2>
<div className='course-btn'>
   <Link to="/LinuxPage">
  <button>View Course</button>
</Link>
</div>
</div>
</div>
<div className='courses-item'>
<div className='courses-img'>
<img src={ccna} alt=''/>
</div>
<div className='course-content'>
  <h2>CCNA</h2>
<div className='course-btn'>
 <Link to="/CCNAPage">
  <button>View Course</button>
</Link>
</div>
</div>
</div>
<div className='courses-item'>
<div className='courses-img'>
<img src={img8} alt=''/>
</div>
<div className='course-content'>
  <h2>Ethical Hacking</h2>
<div className='course-btn'>
   <Link to="/EthicalPage">
  <button>View Course</button>
</Link>
</div>
</div>
</div>

 </div>
 <div className='courses-bottom-box'>
<div className='courses-item'>
<div className='courses-img'>
<img src={img4} alt=''/>
</div>
<div className='course-content2'>
  <h2>Certificate in Cyber Security Course</h2>
  <p>6 months</p>
<div className='course-btn'>
  <Link to="/BasicCyberPage">
  <button>View Course</button>
</Link>
</div>
</div>
</div>

<div className='courses-item'>
<div className='courses-img'>
<img src={img5} alt=''/>
</div>
<div className='course-content2'>
  <h2>Advanced CyberSecurity Course</h2>
  <p>1 year</p>
<div className='course-btn'>
 <Link to="/AdvanceCyberPage">
  <button>View Course</button>
</Link>
</div>
</div>
</div>




</div>
<div>
  <FAQ/>
</div>
      
      </div>
      <div>
        <Footer/>
      </div>
    </div>
  )
}

export default CoursesMain
